module.exports = {"Import":"بارگزاری فایل"}